import React, { useState, useEffect } from "react";
import {
  EllipsisVertical,
  Eye,
  Edit,
  Trash2,
  CheckCircle2,
  Clock3,
  XCircle,
} from "lucide-react";

const ActionMenu = ({
  onView,
  onEdit,
  onDelete,
  onApprove,
  onPending,
  onReject,
  editLabel = "Edit",
  row,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, right: 0 });

  const toggleMenu = (e) => {
    e.stopPropagation();
    if (isOpen) {
      setIsOpen(false);
    } else {
      const rect = e.currentTarget.getBoundingClientRect();
      setPosition({
        top: rect.bottom + 4,
        right: window.innerWidth - rect.right,
      });
      setIsOpen(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".actions-dropdown")) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="actions-dropdown" style={{ position: "relative" }}>
      <button
        className="actions-toggle"
        onClick={toggleMenu}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EllipsisVertical size={18} />
      </button>

      {isOpen && (
        <div
          className="actions-menu"
          style={{
            position: "fixed",
            top: position.top,
            right: position.right,
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            minWidth: "120px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            padding: "4px 0",
          }}
        >
          {onView && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onView(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
              }}
            >
              <Eye size={16} /> View
            </div>
          )}
          {onPending && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onPending(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                color: "#5c308d",
              }}
            >
              <Clock3 size={16} /> Set to Pending
            </div>
          )}
          {onApprove && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onApprove(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                color: "#16a34a",
              }}
            >
              <CheckCircle2 size={16} /> Approve
            </div>
          )}
          {onReject && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onReject(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                color: "#dc2626",
              }}
            >
              <XCircle size={16} /> Reject
            </div>
          )}
          {onEdit && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
              }}
            >
              <Edit size={16} /> {editLabel}
            </div>
          )}
          {onDelete && (
            <div
              className="actions-item"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(row);
                setIsOpen(false);
              }}
              style={{
                padding: "8px 12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                color: "red",
              }}
            >
              <Trash2 size={16} /> Delete
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
